export default "__VITE_ASSET__CMHPPXny__"